import { createApp } from 'vue'
import { createWebHistory, createRouter } from 'vue-router'
import App from '@/App'
import '@/index.css'
import { getFirebaseApp } from '@/firebase'
import { VueFire, VueFireAuth } from 'vuefire'

import HomePageView from '@/pages/HomePage'
import EntouragePageView from '@/pages/EntouragePage'
import AttirePageView from '@/pages/AttirePage'
import RecommendationsPageView from '@/pages/RecommendationsPage'
import SchedulePageView from '@/pages/SchedulePage'
import QuestionsPageView from '@/pages/QuestionsPage'
import AuthPageView from '@/pages/AuthPage'
import ResponseRespondedPageView from '@/pages/ResponseRespondedPage'
import ResponseNamePageView from '@/pages/ResponseNamePage'
import ResponseEventsPageView from '@/pages/ResponseEventsPage'
import ResponseExtraPageView from '@/pages/ResponseExtraPage'
import ResponseSuccessPageView from '@/pages/ResponseSuccessPage'
import AdminPageView from '@/pages/AdminPage'
import AdminGuestsPageView from '@/pages/AdminGuestsPage'

import Group from '@/models/group'

const routes = [
  { path: '/', component: HomePageView, name: 'Home' },
  { path: '/entourage', component: EntouragePageView, name: 'Entourage' , meta: { requiresAuth: true } },
  { path: '/attire', component: AttirePageView, name: 'Attire' , meta: { requiresAuth: true } },
  { path: '/recommendations', component: RecommendationsPageView, name: 'Recommendations' , meta: { requiresAuth: true } },
  { path: '/schedule', component: SchedulePageView, name: 'Schedule' , meta: { requiresAuth: true } },
  { path: '/faq', component: QuestionsPageView, name: 'Q&A' , meta: { requiresAuth: true } },
  { path: '/login', component: AuthPageView, name: 'Authentication' },
  { path: '/rsvp', redirect: { name: 'RSVP Name' } },
  { path: '/rsvp/name', component: ResponseNamePageView, name: 'RSVP Name', meta: { requiresAuth: true } },
  { path: '/rsvp/responded', component: ResponseRespondedPageView, name: 'RSVP Responded', meta: { requiresAuth: true } },
  { path: '/rsvp/events', component: ResponseEventsPageView, name: 'RSVP Event', meta: { requiresAuth: true } },
  { path: '/rsvp/extra', component: ResponseExtraPageView, name: 'RSVP Extra', meta: { requiresAuth: true } },
  { path: '/rsvp/success', component: ResponseSuccessPageView, name: 'RSVP Success', meta: { requiresAuth: true } },
  { path: '/admin', component: AdminPageView, name: 'Admin' },
  { path: '/admin/guests', component: AdminGuestsPageView, name: 'Admin Guest List' },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})
router.beforeEach(async (to) => {
  const group = await Group.current()
  if (to.meta.requiresAuth && !group) {
    return { name: 'Home' }
  }
})

const { firebaseApp } = getFirebaseApp()

createApp(App)
  .use(router)
  .use(VueFire, {
    firebaseApp,
    modules: [
      VueFireAuth()
    ]
  })
  .mount('#app')